import { render, staticRenderFns } from "./CompanyInvoice.vue?vue&type=template&id=21b3ebd9&"
import script from "./CompanyInvoice.vue?vue&type=script&lang=js&"
export * from "./CompanyInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports